import GoldUpgradeCollection from "../upgrade/gold/GoldUpgradeCollection";
import GoldUpgrade from "../upgrade/gold/GoldUpgrade";

export default class GoldUpgradeCollectionSave {
    constructor() {        
    }

    /**
     * @param {GoldUpgradeCollection} upgradeCollection
     * @returns {Object}
     */
    static generateSave(upgradeCollection) {
        const saveState = {};

        saveState.upgrades = [];

        for (let i = 0; i < upgradeCollection.upgrades.length; i++) {
            const upgradeSave = this.generateUpgradeSave(upgradeCollection.upgrades[i]);
            if (!upgradeSave) {
                continue;
            }

            saveState.upgrades.push(upgradeSave);
        }

        saveState.countToPurchase = upgradeCollection.countToPurchase;

        return saveState;
    }

    /**
     * @param {GoldUpgradeCollection} upgradeCollection
     * @param {Object} saveState 
     */
    static loadSave(upgradeCollection, saveState) {
        if (!saveState) {
            console.log('GoldUpgradeCollectionSave.loadSave no save state');
            return;
        }

        const upgradeSaves = saveState.upgrades;
        if (!upgradeSaves) {
            console.log('GoldUpgradeCollectionSave.loadSave state empty');
            return;
        }

        for (let i = 0; i < saveState.upgrades.length; i++) {
            this.loadUpgradeSave(upgradeCollection, saveState.upgrades[i]);
        }

        const countToPurchase = saveState.countToPurchase;
        if (countToPurchase) {
            upgradeCollection.setCountToPurchase(countToPurchase);
        }
    }

    /**
     * @private
     * @param {GoldUpgrade} upgrade 
     * @returns {Object}
     */
    static generateUpgradeSave(upgrade) {
        // Nothing to save if there have been no purchases
        if (upgrade.purchasedCount === 0) {
            return null;
        }

        const upgradeState = {};
 
        upgradeState.id = upgrade.id;
        upgradeState.c = upgrade.purchasedCount;

        return upgradeState;
    }

    /**
     * @private
     * @param {GoldUpgradeCollection} upgradeCollection
     * @param {Object} upgradeState
     */
    static loadUpgradeSave(upgradeCollection, upgradeState) {
        if (!upgradeState) {
            return;
        }

        const id = upgradeState.id;
        const upgrade = upgradeCollection.findById(id);
        if (!upgrade) {
            console.log('GoldUpgradeCollectionSave.loadUpgradeSave() failed to find upgrade id=' + id);
            return;
        }

        const count = upgradeState.c;
        if (count === undefined) {
            return;
        }

        upgrade.setPurchasedCountFromSave(count);
    }

}